"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _accessibility = require("@insided/deprecated-utils/accessibility");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Popover = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    (0, _classCallCheck2.default)(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "containerRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "activeElement", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusableElements", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "nextElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prevElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      (0, _accessibility.handleEscape)(event, _this.props.hide, _this.nextElement);

      _this.handleTab(event);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTab", function (event) {
      var _this$focusableElemen;

      if (event.key !== 'Tab') return;
      _this.focusableElements = (0, _accessibility.getFocusableElements)(_this.containerRef, _this.focusableElements);
      _this.activeElement.current = document.activeElement;
      var isFirstElementFocused = _this.activeElement.current === _this.firstFocusableElement;
      var isLastElementFocused = _this.activeElement.current === _this.lastFocusableElement;
      var isPopoverEmpty = _this.activeElement.current === _this.containerRef.current && ((_this$focusableElemen = _this.focusableElements) === null || _this$focusableElemen === void 0 ? void 0 : _this$focusableElemen.length) === 0;

      if (event.shiftKey && (isFirstElementFocused || _this.activeElement.current === _this.containerRef.current)) {
        _this.handleBackwardTab(event);
      } else if (!event.shiftKey && (isLastElementFocused || isPopoverEmpty)) {
        _this.handleForwardTab(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBackwardTab", function (event) {
      event.preventDefault();
      setTimeout(function () {
        if ((0, _accessibility.isHTMLElement)(_this.prevElement)) _this.prevElement.focus();
      }, 0);

      _this.props.hide();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleForwardTab", function (event) {
      event.preventDefault();
      setTimeout(function () {
        if ((0, _accessibility.isHTMLElement)(_this.nextElement)) _this.nextElement.focus();
      }, 0);

      _this.props.hide();
    });
    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "firstFocusableElement",
    get: function get() {
      var _this$focusableElemen2;

      return (_this$focusableElemen2 = this.focusableElements) === null || _this$focusableElemen2 === void 0 ? void 0 : _this$focusableElemen2[0];
    }
  }, {
    key: "lastFocusableElement",
    get: function get() {
      var _this$focusableElemen3;

      return (_this$focusableElemen3 = this.focusableElements) === null || _this$focusableElemen3 === void 0 ? void 0 : _this$focusableElemen3[this.focusableElements.length - 1];
    } // The prevElement and nextElement neighbors were being set too early in the lifecycle, before the DOM had fully settled. As a result,
    // when trying to focus on these elements, they sometimes could not be found in the DOM because changes to the DOM occurred after setting the neighbors.
    // To address this issue, the logic for setting the prevElement and nextElement has been moved from the popup component to the popover component.

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _setNeighbours = (0, _accessibility.setNeighbours)(this.props.hoverControl),
          nextElement = _setNeighbours.nextElement,
          prevElement = _setNeighbours.prevElement;

      this.nextElement = nextElement;
      this.prevElement = prevElement;
      document.addEventListener('keydown', this.handleKeyDown);
      var popover = this.containerRef.current;

      if ((0, _accessibility.isHTMLElement)(popover)) {
        popover.focus();
      }

      this.focusableElements = (0, _accessibility.getFocusableElements)(this.containerRef, this.focusableElements);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          left = _this$props.left,
          top = _this$props.top,
          zIndex = _this$props.zIndex;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)(this.props.className, 'popup-component'),
        onMouseLeave: function onMouseLeave() {
          _this2.props.toggle(false);
        },
        onMouseEnter: function onMouseEnter() {
          _this2.props.toggle(true);
        },
        ref: function ref(el) {
          _this2.containerRef.current = el;

          if (_this2.props.forwardedRef) {
            _this2.props.forwardedRef(el);
          }
        },
        role: "dialog",
        "aria-modal": "true",
        style: {
          left: left,
          top: top,
          opacity: this.props.size.width ? undefined : 0,
          zIndex: zIndex
        },
        tabIndex: 0
      }, children);
    }
  }]);
  return Popover;
}(_preact.Component);

var _default = Popover;
exports.default = _default;